module.exports = __webpack_public_path__ + "img/icon4.063cf171.png";